import * as React from 'react';

function RightConfetti(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="523" height="105" viewBox="0 0 523 105" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#right_confetti_clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M364.001 21.935C364.001 20.3134 362.682 18.9989 361.054 18.9989C359.427 18.9989 358.108 20.3134 358.108 21.935C358.108 23.5566 359.427 24.8711 361.054 24.8711C362.682 24.8711 364.001 23.5566 364.001 21.935Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M321.001 31.935C321.001 30.3134 319.682 28.9989 318.054 28.9989C316.427 28.9989 315.108 30.3134 315.108 31.935C315.108 33.5566 316.427 34.8711 318.054 34.8711C319.682 34.8711 321.001 33.5566 321.001 31.935Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M478.211 25.2475C478.211 23.6259 476.892 22.3114 475.265 22.3114C473.638 22.3114 472.319 23.6259 472.319 25.2475C472.319 26.8691 473.638 28.1836 475.265 28.1836C476.892 28.1836 478.211 26.8691 478.211 25.2475Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M397.291 4.49087L391.897 9.04828L398.696 11.8271L405.551 14.4474L404.257 7.24509L402.796 0.0681017L397.291 4.49087Z"
          stroke="#ADF9DA"
          strokeWidth="4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M205.63 5.2481C205.63 3.0508 203.842 1.26965 201.637 1.26965C199.433 1.26965 197.645 3.0508 197.645 5.2481C197.645 7.44541 199.433 9.22656 201.637 9.22656C203.842 9.22656 205.63 7.44541 205.63 5.2481Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M429.897 24.9998L423.72 28.9303L430.16 32.2991L429.897 24.9998Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M469.897 94.9998L463.72 98.9303L470.16 102.299L469.897 94.9998Z"
          fill="#5194E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M515.93 39.9299L517.858 46.9766L523.001 41.8515L515.93 39.9299Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M395.207 39.928L397.135 46.9746L402.278 41.8495L395.207 39.928Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M490.991 73.6358L486.81 79.6348L494.055 80.2709L490.991 73.6358Z"
          fill="#FA6C76"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.447 18.0954C109.447 16.9939 108.551 16.101 107.445 16.101C106.34 16.101 105.444 16.9939 105.444 18.0954C105.444 19.1969 106.34 20.0898 107.445 20.0898C108.551 20.0898 109.447 19.1969 109.447 18.0954Z"
          fill="#DCEEF6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M448.001 59.9877C448.001 57.7847 446.209 55.9989 443.998 55.9989C441.787 55.9989 439.995 57.7847 439.995 59.9877C439.995 62.1908 441.787 63.9766 443.998 63.9766C446.209 63.9766 448.001 62.1908 448.001 59.9877Z"
          fill="#F79EAA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M248.143 9.78459C248.143 7.58155 246.351 5.79574 244.141 5.79574C241.93 5.79574 240.138 7.58155 240.138 9.78459C240.138 11.9876 241.93 13.7734 244.141 13.7734C246.351 13.7734 248.143 11.9876 248.143 9.78459Z"
          fill="#F79EAA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.3314 1.58391L46.0001 5.65635L54.0757 10.3594L56.407 6.2863L48.3314 1.58391Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M145.88 8.78761C145.88 11.4314 148.03 13.5742 150.682 13.5742C153.335 13.5742 155.486 11.4314 155.486 8.7876C155.486 6.14382 153.335 4.00099 150.682 4.00099C148.03 4.00099 145.88 6.14382 145.88 8.78761Z"
          stroke="#5194E0"
          strokeWidth="4.268"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M440.331 95.543L443.481 91.4394L435.065 85.2969L431.914 89.4004L440.331 95.543Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M300.717 7.60832L302.021 12.6085L312.061 9.78397L310.757 4.78328L300.717 7.60832Z"
          fill="#EAC54F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M372.94 74.6083L374.244 79.6085L384.284 76.784L382.98 71.7833L372.94 74.6083Z"
          fill="#EAC54F"
        />
      </g>
      <defs>
        <clipPath id="right_confetti_clip0">
          <rect width="523" height="105" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RightConfetti;
